export const ON_MENTION_LINK_REMOVE = 'mention-link/remove'
export const MENTION_CHAR = 'mentionChar'
export const DEFAULT_MENTION_CHAR = '@'
